<template>
  <div class="small-middle">
    <div class="card card--white small-bottom" v-if="assessment.id">
      <div class="card--container">
        <basic-info :assessment="assessment" class="small-bottom"/>
      </div>
    </div>
    <assessment-results class="small-top" :results="results" :referConsultation="false" /> 
  </div>
</template>

<script>
import axios from "axios";
import assessmentResults from "@/components/assessmentResults";
import basicInfo from "./basicInfo";

export default {
  components: {assessmentResults, basicInfo},
  data() {
    return {
      results: [],
      referConsultation: false,
      assessment: { assessment: {} }
    };
  },
  created() {
    let id = this.$route.params.id;
    axios
      .get(`${process.env.VUE_APP_API_URL}coaches/taken-assessments/${id}/break_down/`)
      .then(({ data }) => {
        this.results = data;
      });

    axios
      .get(`${process.env.VUE_APP_API_URL}coaches/taken-assessments/${id}/`)
      .then(({data}) => {
        this.assessment = data;
      });
  }
}
</script>

<style>

</style>
